import Close from "../icons/Close";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import React, { Component } from "react";

import ChatbotUserInterface from "./components/ChatbotUserInterface";
import MessageList from "./components/Conversation/MessageList";
import Trigger from "./components/Trigger";
import { languageContent } from "../../@helpers";
import "./style.scss";

const Chatbot = inject('ChatBotStore')(
  observer(
    class Chatbot extends Component {
      state = {
        shown: true
      };

      toggle() {
        this.setState({
          shown: !this.state.shown
        });
      }

      componentDidMount() {
        const {
          ChatBotStore: { populate }
        } = this.props;
        populate();
      }

      render() {
        const {
          ChatBotStore: {
            messages,
            handleSubmit,
            hasBot,
            showBot,
            promptState,
            closeChatbot,
            toggleChatbot
          }
        } = this.props;
        const content = languageContent();
        const { component } = content;
        const { disclaimer, privacyPolicy, submitBtnTxt } = component.Chatbot;
        const shown = {
          display: this.state.shown ? "flex" : "none"
        };
        const privacyPolicyPath = (!window.lxl_chatbot_lang.privacyPolicyPath
          || 0 === window.lxl_chatbot_lang.privacyPolicyPath.length)
          ? 'privacy-policy'
          : window.lxl_chatbot_lang.privacyPolicyPath;
        return (
          <>
            <aside className="chatbot_container" data-active={showBot}>
              <Trigger
                hasBot={hasBot}
                showBot={showBot}
                handleToggle={toggleChatbot}
              />

              <form
                className="chatbot"
                data-active={showBot}
                onSubmit={handleSubmit}
              >
                <legend className="chatbot_header">
                  <strong>Alma</strong>
                  <button
                    className="button button-icon"
                    type="button"
                    onClick={closeChatbot}
                  >
                    <Close />
                  </button>
                </legend>

                {messages && <MessageList messages={messages} />}

                <aside className="disclaimer" style={shown}>
                  <p>
                    {disclaimer}{" "}
                    <Link target="_blank" to={privacyPolicyPath}>
                      {privacyPolicy}
                    </Link>
              .
            </p>
                  <button
                    type="button"
                    className="button-icon disclaimer__close"
                    onClick={this.toggle.bind(this)}
                  >
                    <Close />
                  </button>
                </aside>
                <ChatbotUserInterface
                  promptState={promptState}
                  showBot={showBot}
                  submitBtnTxt={submitBtnTxt}
                />
              </form>
            </aside>
          </>
          );
        }
      }
  )
)

export default Chatbot;
